<template>
    <div>
        <h3 :class="state_class">{{minutes_string}} : {{seconds_string}}</h3>
        <v-btn ripple @click="init()" class="font14">START</v-btn>
        <v-btn ripple @click="pause = true" class="font14">STOP</v-btn>
        <v-btn ripple @click="stop()" class="font14">RESET</v-btn>
    </div>
</template>

<script>
export default {
  name: 'chronometer',
  props: {
    minutesInit: {
      type: Number,
      default: 4,
      require: false
    },
    secondsInit: {
      type: Number,
      default: 0,
      require: false
    }
  },
  data () {
    return {
      minutes: 0,
      seconds: 0,
      pause: false,
      control: 0,
      negative: false
    }
  },
  mounted () {
    this.minutes = this.minutesInit
    this.seconds = this.secondsInit
  },
  watch: {
    minutesInit (val) {
      this.minutes = val
      this.stop()
    },
    secondsInit (val) {
      this.seconds = val
      this.stop()
    }
  },
  computed: {
    minutes_string () {
      return this.minutes < 10 ? '0' + this.minutes : this.minutes
    },
    seconds_string () {
      return this.seconds < 10 ? '0' + this.seconds : this.seconds
    },
    state_class () {
      let result = ''
      if (this.minutes === 0 && (this.seconds > 0 && this.seconds < 9) && !this.negative) {
        result += ' danger'
      }
      if (this.negative) {
        result += ' negative'
      }
      return result
    }
  },
  methods: {
    step () {
      if (!this.pause) {
        if (this.negative) {
          if (this.seconds < 59) {
            this.seconds++
          } else {
            this.minutes++
            this.seconds = 0
          }
        } else {
          if (this.seconds > 0) {
            this.seconds--
          } else {
            if (this.minutes > 0) {
              this.minutes--
              this.seconds = 59
            } else {
              this.negative = true
              this.seconds = 1
            }
          }
        }
      }
    },
    stop () {
      clearInterval(this.control)
      this.control = 0
      this.minutes = this.minutesInit
      this.seconds = this.secondsInit
      this.negative = false
    },
    init () {
      if (this.pause) {
        this.pause = false
      }
      if (this.control === 0) {
        this.control = setInterval(this.step, 1000)
      }
    }
  }
}
</script>

<style scoped>
    .danger {
        color: #d2691e;
        animation: blink 1s linear infinite;
    }

    .negative {
        color: red;
    }

    .negative::before {
        content: '+ ';
    }

    h3 {
        text-align: center;
        font-size: 125px;
        font-weight: lighter;
    }

    .font14 {
        font-size: 16px;
    }

    @keyframes blink {
        0% {
            opacity: 0;
        }
        50% {
            opacity: .5;
        }
        100% {
            opacity: 1;
        }
    }
</style>
